import styled from "styled-components";
import { FlexRow } from "../../Global.style";

export const HeaderSection = styled(FlexRow)`
  width: 100%;
  height: 60px;
`;
